"use strict";
var XrefsAnnotationPanel_1 = require("./XrefsAnnotationPanel");
exports.XrefsAnnotationPanel = XrefsAnnotationPanel_1.XrefsAnnotationPanel;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9YcmVmc0Fubm90YXRpb25QYW5lbC9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsK0RBQTREO0FBQXBELHNEQUFBLG9CQUFvQixDQUFBIn0=


//////////////////
// WEBPACK FOOTER
// ./~/bridgedb/lib/components/XrefsAnnotationPanel/index.js
// module id = 244
// module chunks = 0